import { getService } from '../utils';

export const getExternalControlSettingsService = getService(
  'externalControlSettings',
);
